import "bootstrap/dist/css/bootstrap.min.css";
import "./sip.scss";

const Social = () => {
  return (
    <div className="row sip-box">
      <div className="col-lg-7 col-md-12 pe-lg-4 px-md-0 left-content">
        <h1 className="left-heading">
         <span className="green"> “</span>A small act of kindness today can create a ripple of change forever.<span className="green">”</span>
        </h1>
      </div>
      <div className="col-lg-5 col-md-12 px-lg-4 px-md-0">
        <h1 className="heading-one">Start your SIP</h1>
        <h1 className="heading-two">Social Impact Plan</h1>
        <p className="para-one">An Investment in Humanity</p>
        <p className="para-two">
          Every contribution counts <br /> <strong>₹500</strong> provides <strong>25 meals</strong> for a day!
        </p>
        <div className="sip-button-box">
            <button className="sip-button">Start SIP</button>
        </div>
      </div>
    </div>
  );
};
export default Social;
